import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { login, Signup, profileAPi, profileImgAPi, UpdateNameAPi ,totalcountapi } from "../../ApiUrl";

export const token = sessionStorage.getItem("accessToken")

const headers = {
  Authorization: `Bearer ${token}`,
};
// get total
export const totalcount = createAsyncThunk("totalcount/getprofile", async () => {
  try {
    const reponse = await axios.get(`${totalcountapi}`, { headers })
    return reponse.data
  } catch (error) {
    throw Error(error)
  }
})

export const SignInAPi = createAsyncThunk('signIn/SignInAPi', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(login, data);
    // Return the token upon successful login
    sessionStorage.setItem("accessToken", response.data.data.accessToken);
    return response.data.data.accessToken;
  } catch (error) {
    // Handle login error
    return rejectWithValue(error.response.data.message);
  }
});
// foget password
export const SignUPAPi = createAsyncThunk("signIn/SignUPAPi", async (data, rejectWithValue) => {
  try {
    const res = await axios.post(Signup, data, { headers });
    const message = res.data.message
    return message;
  } catch (error) {
    return rejectWithValue(error.response.data.message);
  }
});

export const getprofile = createAsyncThunk("signIn/getprofile", async () => {
  try {
    const reponse = await axios.get(`${profileAPi}`, { headers })
    return reponse.data
  } catch (error) {
    throw Error(error)
  }
})

// update profile photo
export const updateprofileImg = createAsyncThunk('signIn/updateprofileImg', async ({ subAdminImg }) => {
  const updateUrl = `${profileImgAPi}`;
  const formData = new FormData();
  formData.append('subAdminImg', subAdminImg);
  try {
    const response = await axios.put(updateUrl,
      formData, { headers }
    );
    const message = response.data.message
    return message;
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data.message;
      return errorMessage;
    } else {
      throw error;
    }
  }
});
// update profile Name
export const updateprofileName = createAsyncThunk('signIn/updateprofileName', async (data) => {
  const updateUrl = `${UpdateNameAPi}`;
  try {
    const response = await axios.put(updateUrl,
      data, { headers }
    );
    const message = response.data.message
    return message;
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data.message;
      return errorMessage;
    } else {
      throw error;
    }
  }
});

const authSlice = createSlice({
  name: "signIn",
  initialState: {
    profile: [],
    getotalcount:[],
    status: 'idle',
    error: null,
    message: null,
    accessToken: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
     // get total
     .addCase(totalcount.pending, (state) => {
      state.status = 'loading';
    })
    .addCase(totalcount.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.getotalcount = action.payload;
    })
    .addCase(totalcount.rejected, (state, action) => {
      state.status = 'failed';
    })
      //login  
      .addCase(SignInAPi.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(SignInAPi.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.accessToken = action.payload;
        state.error = null;
        // const history = useNavigate(); // Initialize useHistory hook
        // history.push('/home'); // Redirect to home page upon successful login
      })
      .addCase(SignInAPi.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to load data';
      })
      // register
      .addCase(SignUPAPi.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(SignUPAPi.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.message = action.payload;
        state.error = null;
      })
      .addCase(SignUPAPi.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to load data';
      })
      // get profile
      .addCase(getprofile.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getprofile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.profile = action.payload;
      })
      .addCase(getprofile.rejected, (state, action) => {
        state.status = 'failed';
      })
     
      // update profile image
      .addCase(updateprofileImg.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateprofileImg.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.message = action.payload
      })
      .addCase(updateprofileImg.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload
      })
      // update profile Name
      .addCase(updateprofileName.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateprofileName.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.message = action.payload
        // state.status = 'idle'
      })
      .addCase(updateprofileName.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload
      })
  },
});

export default authSlice.reducer;
